export default {"src":"/_next/static/media/door-selection.94f5ade6.svg","height":25,"width":18,"blurWidth":0,"blurHeight":0};